import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import EmployeeDataIcon from "../Icons/EmployeeData.svg";
import ManageLookUpsIcon from "../Icons/ManageLookUps.svg";
import ProfileIcon from "../Icons/profile.svg";
import LoginEmail from "./loginEmail";
import DashboardIcon from "../Icons/dashboardIcon.svg";
import { getToken } from "../services/Token";
import LeaveBalanceIcon from "../Icons/leave-balance.svg";
import ApplyLeaveIcon from "../Icons/leave-apply.svg";
import Tooltip from "@mui/material/Tooltip";
import LeavePolicy from "../Icons/leave-policy.svg";
import reviewIcon from "../Icons/review-file.svg";
import editIcon from "../Icons/edit-content.svg";
import letterAdmin from "../Icons/Letter-Admin.svg";
import letterEmployee from "../Icons/Letters-Employee.svg";
import trainingIcon from "../Icons/TrainingIcon.svg";
import tenantIcon from "../Icons/Tenants.svg";
import calendar from "../Icons/Calendar.svg";
import generateLetters from "../Icons/generate-Letters.svg";
import workLog from "../Icons/workLog.svg";
import project from "../Icons/Projects.svg";
import payroll from "../Icons/payroll.svg";
import employeeLogin from "../Icons/employeeLogin.svg";
import attendanceIcon from "../Icons/attendance-icon.svg";
import applyRegularizationIcon from "../Icons/applyRegularizationIcon.svg";
import reviewRegularizationIcon from "../Icons/reviewRegularizationIcon.svg";
import handshake from "../Icons/handshake.svg";
import orgChartIcon from "../Icons/OrgChartIcon.svg";
import engageIcon from "../Icons/engage.svg";


import { useDispatch, useSelector } from "react-redux";
import {
  setAdditionalFields,
  setNavigation,
  setSelectType,
} from "../store/reducers/payrollSlice";
import paySlipIcon from "../Icons/payslipIcon.svg";
import timesheet from "../Icons/Timesheet.svg";
import AnnouncementBanner from "./Announcement";
import Sidebar from "./Sidebar";
import MenuIcon from "../Icons/Menu.svg";

const Layout = ({ children }) => {
  const [showSidebar, setShowSidebar] = useState(true);
  const tenantCountry = getToken("tenantCountry");
  const visibelDashboards = getToken("dashboards");
  const location = useLocation();
  const dispatch = useDispatch();
  const {isAnnouncementOpen} = useSelector((state) => state.notification);

  const main = (
    <main
      className={`${isAnnouncementOpen ? "mt-28" : "mt-14"}`}
      style={{
        width: showSidebar ? "calc(100vw - 320px)" : "100vw",
      }}
    >
      {children}
    </main>
  );
  const role = getToken("roles");
  const isEmployee = role ? role.includes("EMPLOYEE") : false;
  const isManager = role ? role.includes("MANAGER") : false;
  const isAdmin = role ? role.includes("ADMIN") : false;
  const isSuperUser = role ? role.includes("SUPERADMIN") : false;

  const getDashboards = (code) => {
    if (visibelDashboards) {
      if (visibelDashboards.includes(code)) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const navigation = [
    {
      name: "Dashboard",
      icon: DashboardIcon,
      href: "/dashboard",
      current: location.pathname === "/dashboard",
      isVisible: true,
      subItems: [],
    },
    {
      name: "Profile",
      icon: ProfileIcon,
      href: "/editprofile",
      current: location.pathname === "/editprofile",
      isVisible: false,
      subItems: [],
    },
    {
      name: "Employee Data",
      icon: EmployeeDataIcon,
      href: "/manage",
      current: location.pathname === "/manage",
      isVisible: getDashboards(4001) && isAdmin,
      subItems: [],
    },
    {
      name: "Manage LookUps",
      icon: ManageLookUpsIcon,
      href: "/managelookups",
      current: location.pathname === "/managelookups",
      isVisible: getDashboards(4001) && isAdmin,
      subItems: [],
    },
    {
      name: "Holiday Calendar",
      icon: calendar,
      href: isAdmin ? "/holidayCalendar" : "/userHolidayCalendar",
      current:
        location.pathname === "/holidayCalendar" ||
        location.pathname === "/userHolidayCalendar",
      isVisible: getDashboards(4001),
      subItems: [],
    },
    {
      name: "Payroll",
      icon: payroll,
      href: "/payroll",
      current: location.pathname === "/payroll",
      isVisible: getDashboards(4006) && isAdmin && tenantCountry !== "USA",
      subItems: [],
    },
    {
      name: "Leave Balance",
      icon: LeaveBalanceIcon,
      href: "/leavebalance",
      current: location.pathname === "/leavebalance",
      isVisible: getDashboards(4002) && (isEmployee || isManager),
      subItems: [],
    },
    {
      name: "Apply Leave",
      icon: ApplyLeaveIcon,
      href: "/leaves",
      current: location.pathname === "/leaves",
      isVisible: getDashboards(4002) && (isEmployee || isManager),
      subItems: [],
    },
    {
      name: "Apply Leave on Behalf",
      icon: ApplyLeaveIcon,
      href: "/leaves/on-behalf",
      current: location.pathname === "/leaves/on-behalf",
      isVisible: getDashboards(4002) && isAdmin,
      subItems: [],
    },
    {
      name: "Leave Policy",
      icon: LeavePolicy,
      href: "/leavepolicy",
      current: location.pathname === "/leavepolicy",
      isVisible: getDashboards(4002) && isAdmin,
      subItems: [],
    },
    {
      name: "Review",
      icon: reviewIcon,
      href: "/review",
      current: location.pathname === "/review",
      isVisible: getDashboards(4002) && (isAdmin || isManager),
      subItems: [],
    },
    {
      name: "Edit Employee",
      icon: editIcon,
      href: tenantCountry === "USA" ? "/usaedit" : "/edit",
      current:
        location.pathname === "/edit" || location.pathname === "/usaedit",
      isVisible: getDashboards(4001) && isAdmin,
      subItems: [],
    },
    {
      name: "Create Letter",
      icon: letterEmployee,
      href: "/lettertemplate",
      current: location.pathname === "/lettertemplate",
      isVisible: getDashboards(4003) && isAdmin,
      subItems: [],
    },
    {
      name: "Generate Letters",
      icon: generateLetters,
      href: "/generate",
      current: location.pathname === "/generate",
      isVisible: getDashboards(4003) && isAdmin,
      subItems: [],
    },
    {
      name: "Letters",
      icon: letterAdmin,
      href: "/letters",
      current: location.pathname === "/letters",
      isVisible: getDashboards(4003) && isAdmin,
      subItems: [],
    },
    {
      name: "Letters",
      icon: letterEmployee,
      href: "/employeeletters",
      current: location.pathname === "/employeeletters",
      isVisible: getDashboards(4003) && (isEmployee || isManager),
      subItems: [],
    },
    {
      name: "Time Sheet",
      icon: workLog,
      href: "/workLog",
      current:
        location.pathname === "/workLog",
      isVisible: getDashboards(4004) && (isEmployee || isManager),
      subItems: [],
    },
    {
      name: "Employee TimeSheets",
      icon: timesheet,
      href: "/worklogadmin",
      current: location.pathname === "/worklogadmin",
      isVisible: getDashboards(4004) && (isAdmin || isManager),
      subItems: [],
    },
    {
      name: "Employee Status Reports",
      icon: reviewIcon,
      href: "/employee-status-reports",
      current: location.pathname === "/employee-status-reports",
      isVisible: getDashboards(4004) && (isAdmin || isManager),
      subItems: [],
    },
    {
      name: "Status Report",
      icon: timesheet,
      href: "/status-reports",
      current: location.pathname === "/status-reports",
      isVisible: getDashboards(4004) && (isEmployee || isManager),
      subItems: [],
    },
    {
      name: "Assign Projects",
      icon: project,
      href: "/assignprojects",
      current: location.pathname === "/assignprojects",
      isVisible: getDashboards(4004) && (isManager || isAdmin),
      subItems: [],
    },
    {
      name: "Training Modules",
      icon: trainingIcon,
      href: "/trainingModules",
      current: location.pathname === "/trainingModules",
      isVisible: getDashboards(4005) && true,
      subItems: [],
    },
    {
      name: "Tenants",
      icon: tenantIcon,
      href: "/superadmin",
      current: location.pathname === "/superadmin",
      isVisible: isSuperUser,
      subItems: [],
    },
    {
      name: "Payslips",
      icon: paySlipIcon,
      href: "/payslip",
      current: location.pathname === "/payslip",
      isVisible:
        getDashboards(4002) && (isEmployee || isManager) &&
        tenantCountry !== "USA",
      subItems: [],
    },
    {
      name: "Attendance Info",
      icon: attendanceIcon,
      href: "/attendance",
      current: location.pathname === "/attendance",
      isVisible: getDashboards(4002) && isEmployee,
      subItems: [
        {
          name: "Apply Regularization",
          icon: applyRegularizationIcon,
          href: "/apply-regularization",
          isVisible: true,
          current: location.pathname === "/apply-regularization",
        },
      ],
    },
    {
      name: "Attendance Info",
      icon: attendanceIcon,
      href: "/attendanceinfo",
      current: location.pathname === "/attendanceinfo",
      isVisible: getDashboards(4002) && (isManager || isAdmin),
      subItems: [
        {
          name: "Apply Regularization",
          icon: applyRegularizationIcon,
          href: "/apply-regularization",
          isVisible: true,
          current: location.pathname === "/apply-regularization",
        },
        {
          name: "Review Regularization",
          icon: reviewRegularizationIcon,
          href: "/review-regularization",
          isVisible: true,
          current: location.pathname === "/review-regularization",
        }
      ],
    },
    {
      // One route for both audiences - the screen itself decides between the
      // employee flow and the admin review queue based on the logged-in role.
      // Managers are deliberately excluded (2026-08-25): they get no resignation
      // entry at all. Written as `isAdmin || ...` so an account carrying both
      // ADMIN and MANAGER keeps the review queue.
      name: isAdmin ? "Resignation & Exit" : "Resignation",
      icon: handshake,
      href: "/resignation",
      current: location.pathname === "/resignation",
      isVisible: isAdmin || (isEmployee && !isManager),
      subItems: [],
    },
    {
      name: "Engage",
      icon: engageIcon,
      href: "/engage",
      current: location.pathname === "/engage",
      isVisible: true,
      subItems: [],
    },
    {
      name: "Employee Login's",
      icon: employeeLogin,
      href: "/employeetracking",
      current: location.pathname === "/employeetracking",
      isVisible: getDashboards(4002) && isAdmin,
      subItems: [],
    },
    {
      name: "Organization Chart",
      icon: orgChartIcon,
      href: "/orgchart",
      current: location.pathname === "/orgchart",
      isVisible: isAdmin || isManager || isEmployee,
      subItems: [],
    },
  ];

  const navigate = useNavigate();

  const handleSidebarToggle = () => {
    setShowSidebar(!showSidebar);
  };

  const handleClick = (item) => {
    if (item.isVisible) {
      navigate(item.href);
    }
    dispatch(setAdditionalFields(""));
    dispatch(setSelectType(""));
    dispatch(setNavigation(false));
  };


  const topbar = (
    <nav
      id="navbar"
      className={`z-[2] h-20 fixed ${
        isAnnouncementOpen ? "top-14" : "top-0"
      }  flex bg-white px-4 items-center flex-row justify-between border-b border-gray-300 py-4`}
      style={{
        width: showSidebar ? "calc(100vw - 320px)" : "100vw",
      }}
    >
      <div className="flex flex-row items-center justify-between">
        {!showSidebar && (
          <button
            id="btnSidebarToggler"
            type="button"
            className="text-2xl text-black ml-[5px]"
            onClick={handleSidebarToggle}
          >
            <div className="h-10 w-10 flex items-center justify-center rounded-full bg-[#F8F9FA]">
              <img src={MenuIcon} alt="Menu" />
            </div>
          </button>
        )}
        <div className="cursor-pointer relative mr-4">
          {navigation.map(
            (item, index) =>
              item.current && (
                <div
                  key={index + 1}
                  className="text-20 font-medium font-Avenir text-[#3C424C]"
                >
                  <div className="ml-2 text-2xl font-semibold">
                    {" "}
                    {item.name}
                  </div>
                </div>
              )
          )}
        </div>
      </div>

      <section className="flex">
        <Tooltip
          title="Help Document"
          className="my-auto cursor-pointer"
          onClick={() => {
            isAdmin
              ? window.open(
                  "https://ei-help-document-admin.web.app/",
                  "_blank",
                  "noopener"
                )
              : window.open(
                  "https://ei-help-document.web.app/",
                  "_blank",
                  "noopener"
                );
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="w-6 h-6"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M9.879 7.519c1.171-1.025 3.071-1.025 4.242 0 1.172 1.025 1.172 2.687 0 3.712-.203.179-.43.326-.67.442-.745.361-1.45.999-1.45 1.827v.75M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-9 5.25h.008v.008H12v-.008z"
            />
          </svg>
        </Tooltip>
        <div className="text-20 font-medium font-Avenir text-[#3C424C] ml-2 mr-[5rem]">
          <LoginEmail isAdmin={isAdmin} />
        </div>
      </section>
    </nav>
  );


  return (
    <>
      <AnnouncementBanner />
      <div className="flex flex-row bg-[#f8f9fd] overflow-hidden min-h-screen z-50">
        {showSidebar && (
          <Sidebar
            handleClick={handleClick}
            handleSidebarToggle={handleSidebarToggle}
            navigation={navigation}
            showSidebar={showSidebar}
          />
        )}
        <div className="w-full ">
          {topbar}
          {main}
        </div>
      </div>
    </>
  );
};

export default Layout;
